import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, InputSignal, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { LocaleConfig, TranslationStoreService } from '@ogs-gmbh/ngx-translate';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";

@Component({
  selector: 'app-date-time',
  standalone: true,
  imports: [ IconModule, DatePipe ],
  templateUrl: './date-time.component.html',
  styleUrl: './date-time.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateTimeComponent {
  private _translationStoreService: TranslationStoreService = inject(TranslationStoreService);

  private _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  public date: InputSignal<Date> = input(new Date());

  protected currentLocale: Signal<LocaleConfig | undefined> = toSignal(this._translationStoreService.getLocale$());

  constructor () {
    this._faIconLibrary.addIcons(faCalendar);
  }
}
